import { TooltipDesignTokens } from '@primeuix/themes/aura/tooltip';

export const tooltipTokens: TooltipDesignTokens = {
  root: {
    maxWidth: '12.5rem',
    gutter: '0.25rem',
    shadow: '{overlay.popover.shadow}',
    padding: '0.5rem 0.75rem',
    borderRadius: '{overlay.popover.border.radius}',
  },
  colorScheme: {
    light: {
      root: {
        background: '{violet.800}',
        color: '{surface.0}',
      },
    },
    dark: {
      root: {
        background: '{violet.50}',
        color: '{primary.950}',
      },
    },
  },
};
